t = require('views/internal/teacup-with-helpers')('woof_header')

module.exports = ->
  t.a '.header-btn.header-woof', { href: '#' }, ->
    t.span '.taco-talk-small-icon'
    t.span '.header-btn-text', ->
      t.span '.left-arrow'
      t.span '.js-phrase'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/woof_header.coffee